import { render, staticRenderFns } from "./PcIdxNum12MContent.vue?vue&type=template&id=15fbcf63&"
import script from "./PcIdxNum12MContent.vue?vue&type=script&lang=js&"
export * from "./PcIdxNum12MContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports